





















import { Component, Prop, Mixins } from "vue-property-decorator";
import DateRanges from "@/data/dateranges";
import StatsStorageMixin from "@/mixins/statsStorageMixin";
@Component({
  components: {
    "stat-header": () => import("@/components/app/global/stats/statHeader.vue")
  }
})
export default class AdminTransactionsView extends Mixins(StatsStorageMixin) {
  // Props
  @Prop({ default: () => () => [] })
  public routes!: () => any;
  // Data
  public range = this.tryGetStatDateFromStorage(DateRanges.ranges.last30days);
  public currencyCode = null;
}
